import React from "react";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import BreadcrumbPurchaseOrder from "../../components/screen/purchaseOrder/BreadcrumbPurchaseOrder";
import AddPurchaseOrder from "../../components/screen/purchaseOrder/AddPurchaseOrder";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";

const PurchaseOrder = ({ isEdit, isWarehouse }) => {
  return (
    <div className="">
      <PageTemplate
        header={`${isWarehouse ? "Central Warehouse" : ""} ${
          isEdit ? "Edit" : "Add"
        } Purchase Order Manual`}
        breadcrumb={
          <BreadcrumbPurchaseOrder
            isWarehouse={isWarehouse ? isWarehouse : false}
          />
        }
        mainComponent={
          <ThemeProvider theme={theme}>
            <AddPurchaseOrder
              isEdit={isEdit}
              isWarehouse={isWarehouse ? isWarehouse : false}
            />
          </ThemeProvider>
        }
        pageRole={isWarehouse ? 29 : 9}
        noPadding={true}
      />
    </div>
  );
};

export default HOC(PurchaseOrder);
